<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Invoice Notes</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <form
      [formGroup]="formData"
      class="invoice-note-form__wrapper"
      (submit)="onSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Public Note</label>
            <textarea
              ngDefaultControl
              rows="5"
              class="lum-textarea"
              placeholder="Add note here..."
              formControlName="public_note"
              [value]="public_note"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Private Note</label>
            <textarea
              ngDefaultControl
              rows="5"
              class="lum-textarea"
              placeholder="Add note here..."
              formControlName="private_note"
              [value]="private_note"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="lum-modal__footer">
        <div class="flex ml-auto lum-modal__action">
          <button
            type="button"
            class="lum-button lum-button--secondary mr-2"
            mat-button
            (click)="onClose()"
          >
            Discard
            <lum-ui-icon
              icon="close-circle"
              color="#5563D6"
              width="23"
              height="23"
            ></lum-ui-icon>
          </button>

          <button mat-button type="submit" class="lum-button">
            Save
            <lum-ui-icon
              class="ml-2-5"
              icon="content-save"
              color="#ffffff"
              width="23"
              height="23"
            ></lum-ui-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
